import {
	DAILY_REPORT_REQUESTING,
	DAILY_REPORT_ERROR,
	DAILY_REPORT_SUCCESS,
	TOTAL_DAILY_REPORT,
	LOAD_TOTAL_REPORT,
} from './types';

export const initialState = {
	loading: false,
	totalListLoading: false,
	data: [],
	error: undefined,
	totalData: [],
};

function dailyReport(state = initialState, action) {
	switch (action.type) {
		case DAILY_REPORT_REQUESTING:
			return {
				...state,
				loading: true,
				data: [],
				error: undefined,
			};
		case DAILY_REPORT_SUCCESS:
			return {
				...state,
				data: action.data,
				loading: false,
				totalData: action.data,
			};
		case LOAD_TOTAL_REPORT:
			return {
				...state,
				loading: false,
				totalListLoading: true,
				error: undefined,
			};
		case TOTAL_DAILY_REPORT:
			return {
				...state,
				data: action.data,
				totalListLoading: false,
				totalData: [...state.totalData, ...action.data],
				loading: false,
			};
		case DAILY_REPORT_ERROR:
			return {
				...state,
				totalListLoading: false,
				error: action.error,
				loading: false,
			};
		default:
			return state;
	}
}

export default dailyReport;
